export default __webpack_public_path__ + "static/media/gallery-wip-emitter-tip_06.2417e978.jpg";